export default {
  path: ":alias/parents",
  component: resolve => require(["@/views/parents"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/parents/list"], resolve)
    }
  ]
};
